export var TextCssClass;
(function (TextCssClass) {
    TextCssClass["Base"] = "iress-text";
    TextCssClass["NoGutter"] = "iress-text--no-gutter";
    TextCssClass["Inline"] = "iress-text--inline";
    TextCssClass["Heading"] = "iress-text--heading";
    TextCssClass["Display"] = "iress-text--display";
})(TextCssClass || (TextCssClass = {}));
export var TextVariant;
(function (TextVariant) {
    TextVariant["Blockquote"] = "blockquote";
    TextVariant["Body"] = "body";
    TextVariant["Bold"] = "bold";
    TextVariant["Buy"] = "buy";
    TextVariant["Code"] = "code";
    TextVariant["Danger"] = "danger";
    TextVariant["Display"] = "display";
    TextVariant["Display1"] = "display1";
    TextVariant["Display2"] = "display2";
    TextVariant["Display3"] = "display3";
    TextVariant["Display4"] = "display4";
    TextVariant["Heading1"] = "h1";
    TextVariant["Heading2"] = "h2";
    TextVariant["Heading3"] = "h3";
    TextVariant["Heading4"] = "h4";
    TextVariant["Heading5"] = "h5";
    TextVariant["Heading6"] = "h6";
    TextVariant["Info"] = "info";
    TextVariant["Italic"] = "italic";
    TextVariant["Lead"] = "lead";
    TextVariant["Muted"] = "muted";
    TextVariant["Sell"] = "sell";
    TextVariant["Small"] = "small";
    TextVariant["Success"] = "success";
    TextVariant["Warning"] = "warning";
})(TextVariant || (TextVariant = {}));
export var TextElement;
(function (TextElement) {
    TextElement["P"] = "p";
    TextElement["Div"] = "div";
    TextElement["Span"] = "span";
    TextElement["H1"] = "h1";
    TextElement["H2"] = "h2";
    TextElement["H3"] = "h3";
    TextElement["H4"] = "h4";
    TextElement["H5"] = "h5";
    TextElement["H6"] = "h6";
    TextElement["Code"] = "code";
    TextElement["Blockquote"] = "blockquote";
    TextElement["Caption"] = "caption";
    TextElement["Cite"] = "cite";
    TextElement["Small"] = "small";
    TextElement["Divider"] = "hr";
})(TextElement || (TextElement = {}));
//# sourceMappingURL=text.types.js.map